(function () {
  const CONFIG_ID = 'NivodaDeliveryMessageConfig';
  const ROOT_SELECTOR = '#diamond-proxy-root';
  const BUTTON_SELECTOR = '.diamond-proxy-add-to-cart';
  const MESSAGE_CLASS = 'nivoda-delivery-message';
  const MESSAGE_SELECTOR = `.${MESSAGE_CLASS}`;
  const RING_SETTINGS_CLASS = 'vermore-diamond-ring-settings-link';
  const RING_SETTINGS_SELECTOR = `.${RING_SETTINGS_CLASS}`;
  const DETAIL_QUERY_PARAM = 'id';
  const DEFAULT_CONFIG = {
    label: 'Estimated delivery time',
    duration: 'About 8-10 business days',
    ringSettingsLabel: 'Ring setting styles',
    ringSettingsUrl: '/collections/求婚戒指款式',
  };

  function readConfig(doc) {
    const configElement = doc && doc.getElementById ? doc.getElementById(CONFIG_ID) : null;

    if (!configElement || !configElement.textContent) {
      return DEFAULT_CONFIG;
    }

    try {
      const config = JSON.parse(configElement.textContent);
      return {
        label: config.label || DEFAULT_CONFIG.label,
        duration: config.duration || DEFAULT_CONFIG.duration,
        ringSettingsLabel: config.ringSettingsLabel || DEFAULT_CONFIG.ringSettingsLabel,
        ringSettingsUrl: config.ringSettingsUrl || DEFAULT_CONFIG.ringSettingsUrl,
      };
    } catch (_error) {
      return DEFAULT_CONFIG;
    }
  }

  function getActionTarget(button) {
    if (!button) return null;
    const parent = button.parentElement;

    if (parent && parent.tagName === 'BUTTON') {
      return parent;
    }

    return button;
  }

  function isDiamondDetailView(doc) {
    const location = doc && doc.location ? doc.location : null;
    const search = location && location.search ? location.search : '';

    if (!search) return false;

    try {
      const params = new URLSearchParams(search);
      return params.has(DETAIL_QUERY_PARAM) && params.get(DETAIL_QUERY_PARAM) !== '';
    } catch (_error) {
      return new RegExp(`[?&]${DETAIL_QUERY_PARAM}=[^&]+`).test(search);
    }
  }

  function removeDeliveryMessages(root) {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll(MESSAGE_SELECTOR).forEach((message) => {
      if (message && message.remove) {
        message.remove();
      }
    });
  }

  function createTruckIcon(doc) {
    const svg = doc.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 1024 1024');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('class', 'nivoda-delivery-message__icon');

    const path = doc.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute(
      'd',
      'M691.8 400.5c-9.7-14.8-5.6-34.6 9.2-44.3 14.8-9.7 34.6-5.6 44.3 9.2L836 503.8c9.7 14.8 5.6 34.6-9.2 44.3-14.8 9.7-34.6 5.6-44.3-9.2l-90.7-138.4zM736 896c41.2 0 74.7-33.4 74.7-74.7s-33.4-74.7-74.7-74.7-74.7 33.4-74.7 74.7S694.8 896 736 896z m-448 0c41.2 0 74.7-33.4 74.7-74.7s-33.4-74.7-74.7-74.7-74.7 33.4-74.7 74.7S246.8 896 288 896zM106.7 149.3V512h384V149.3h-384z m512.4 597.4c24.6-38.5 67.8-64 116.9-64s92.2 25.5 116.9 64h64.5v-234l-140.3-214H554.7V512c0 35.3-28.7 64-64 64h-384v170.7h64.5c24.6-38.5 67.8-64 116.9-64s92.2 25.5 116.9 64h214.1z m-21.4 64H426.3c0.3 3.5 0.4 7.1 0.4 10.7 0 76.6-62.1 138.7-138.7 138.7S149.3 898 149.3 821.4c0-3.6 0.1-7.1 0.4-10.7h-43.1c-35.3 0-64-28.7-64-64V128c0-23.6 19.1-42.7 42.7-42.7h405.3c35.3 0 64 28.7 64 64v85.3h245.5c7.2 0 13.9 3.6 17.8 9.6l159.8 244c2.3 3.5 3.5 7.5 3.5 11.7v246.7c0 35.3-28.7 64-64 64h-43.1c0.3 3.5 0.4 7.1 0.4 10.7 0 76.6-62.1 138.7-138.7 138.7s-138.7-62.1-138.7-138.7c0.2-3.6 0.4-7.1 0.6-10.6z'
    );
    svg.appendChild(path);

    return svg;
  }

  function createMessage(doc, config) {
    const wrapper = doc.createElement('div');
    wrapper.className = MESSAGE_CLASS;
    wrapper.dataset.nivodaDeliveryMessage = 'true';

    const label = doc.createElement('span');
    label.className = 'nivoda-delivery-message__label';
    label.textContent = config.label;

    const duration = doc.createElement('span');
    duration.className = 'nivoda-delivery-message__duration';
    duration.textContent = config.duration;

    wrapper.append(createTruckIcon(doc), label, duration);
    return wrapper;
  }

  function createRingSettingsLink(doc, config) {
    const link = doc.createElement('a');
    link.className = RING_SETTINGS_CLASS;
    link.href = config.ringSettingsUrl;
    link.textContent = config.ringSettingsLabel;
    return link;
  }

  function insertRingSettingsLink(root, config, doc) {
    if (!root || !root.querySelector || !isDiamondDetailView(doc)) return false;

    const button = root.querySelector(BUTTON_SELECTOR);
    const target = getActionTarget(button);
    if (!target || !target.parentElement) return false;

    const existing = root.querySelector(RING_SETTINGS_SELECTOR);
    if (existing) return true;

    target.insertAdjacentElement('beforebegin', createRingSettingsLink(doc, config));
    return true;
  }

  async function getCartItemCount(win) {
    const response = await win.fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('Unable to read cart');

    const cart = await response.json();
    return Number(cart.item_count) || 0;
  }

  function notifyCartUpdated(doc, itemCount) {
    doc.dispatchEvent(
      new doc.defaultView.CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          data: {
            source: 'nivoda-diamond',
            itemCount,
          },
        },
      })
    );

    const drawer = doc.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    }
  }

  function keepNivodaOnCurrentPage(doc, win) {
    if (!isDiamondDetailView(doc) || typeof Nivoda === 'undefined' || !Nivoda.routes) return false;

    Nivoda.routes.cart_url = `${win.location.pathname}${win.location.search}#cart-drawer`;
    return true;
  }

  function installCartAddInterceptor(doc, win) {
    if (!isDiamondDetailView(doc) || typeof win.fetch !== 'function') return false;
    if (win.fetch.vermoreCartDrawerInterceptor) return true;

    const originalFetch = win.fetch;
    const interceptedFetch = function (input, init) {
      const requestUrl = String(input && input.url ? input.url : input);
      const responsePromise = originalFetch.call(win, input, init);

      if (!/\/cart\/add(?:\.js)?(?:\?|$)/.test(requestUrl)) return responsePromise;

      return responsePromise.then((response) => {
        if (response.ok) {
          win.setTimeout(async () => {
            try {
              const itemCount = await getCartItemCount(win);
              notifyCartUpdated(doc, itemCount);
            } catch (_error) {
              // The item was added; the existing header cart remains the recovery path.
            }
          }, 0);
        }

        return response;
      });
    };

    Object.defineProperty(interceptedFetch, 'vermoreCartDrawerInterceptor', { value: true });
    win.fetch = interceptedFetch;
    return true;
  }

  function insertDeliveryMessage(root, config, doc) {
    if (!root || !root.querySelector) return false;

    if (!isDiamondDetailView(doc)) {
      removeDeliveryMessages(root);
      return false;
    }

    const button = root.querySelector(BUTTON_SELECTOR);
    const target = getActionTarget(button);

    if (!target || !target.parentElement) return false;

    if (target.nextElementSibling && target.nextElementSibling.classList.contains(MESSAGE_CLASS)) {
      return true;
    }

    target.insertAdjacentElement('afterend', createMessage(doc, config));
    return true;
  }

  function applyDeliveryMessage(doc, config, win) {
    const root = doc.querySelector ? doc.querySelector(ROOT_SELECTOR) : null;
    if (!root) return false;

    insertRingSettingsLink(root, config, doc);
    insertDeliveryMessage(root, config, doc);
    keepNivodaOnCurrentPage(doc, win);
    installCartAddInterceptor(doc, win);
    return true;
  }

  function init(doc, win) {
    if (!doc || !doc.body || !win || !win.MutationObserver) return null;

    const config = readConfig(doc);
    const apply = () => applyDeliveryMessage(doc, config, win);
    apply();

    const observer = new win.MutationObserver(apply);
    observer.observe(doc.body, { childList: true, subtree: true });
    return observer;
  }

  const api = {
    readConfig,
    getActionTarget,
    isDiamondDetailView,
    createMessage,
    createRingSettingsLink,
    insertRingSettingsLink,
    insertDeliveryMessage,
    getCartItemCount,
    notifyCartUpdated,
    keepNivodaOnCurrentPage,
    installCartAddInterceptor,
    applyDeliveryMessage,
    init,
  };

  if (typeof window !== 'undefined') {
    window.NivodaDeliveryMessage = api;

    if (window.document) {
      init(window.document, window);
    }
  }
})();
